module.exports = __webpack_public_path__ + "static/img/home_content_1.a20befd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/home_content_1.png
// module id = /pRq
// module chunks = 1